import curvature_comb_raw from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/Top/search/curvature_comb_settings.svg';

export const CurvatureCombIcon = curvature_comb_raw;
